// src/store/faq/faq.selectors.ts
import { useFaqStore } from "./faq.store";

export const useFaqPage = () => useFaqStore((s) => s.page);
export const useFaqSize = () => useFaqStore((s) => s.size);
export const useFaqOrder = () => useFaqStore((s) => s.order);

export const useSetFaqQuery = () => useFaqStore((s) => s.setQuery);
export const useResetFaqQuery = () => useFaqStore((s) => s.resetQuery);
